<div
  class="file-handler {{!isUploading && downloadUrl ? 'p-0' : ''}}"
  ngFileDrop
  [options]="options"
  (uploadOutput)="onUploadOutput($event)"
  [uploadInput]="uploadInput"
  [class.file-handler--drag-over]="dragOver"
  [class.file-handler--uploading]="isUploading"
  (click)="triggerBrowse(fileInput)"
>
  <input
    #fileInput
    type="file"
    class="file-handler__input"
    [accept]="accept"
    ngFileSelect
    [options]="options"
    (uploadOutput)="onUploadOutput($event)"
    [uploadInput]="uploadInput"
  />

  <ng-container *ngIf="!(isUploading || fileId); else fileSummary">
    <div class="file-handler__state">
      <div class="file-handler__icon">
        <i class="far fa-upload magic-color"></i>
      </div>
      <div class="file-handler__text mt-2" *ngIf="label || description">
        <div *ngIf="label" class="file-handler__label magic-color">{{ label }}</div>
        <div *ngIf="description" class="file-handler__description">{{ description }}</div>
        <div *ngIf="allowedFormatsDescription" class="file-handler__description file-handler__description--formats">
          Accepted formats: {{ allowedFormatsDescription }}
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #fileSummary>
    <div class="file-handler__file" [class.file-handler__file--loading]="isUploading" (click)="$event.stopPropagation()">
      <div
        class="file-handler__icon file-handler__icon--file"
        [class.file-handler__icon--loading]="isUploading"
        [class.file-handler__icon--has-preview]="!!filePreviewUrl"
      >
        <ng-container *ngIf="filePreviewUrl; else fileIcon">
          <img class="file-handler__preview" [src]="filePreviewUrl" [alt]="fileName || 'File preview'" />
        </ng-container>
        <ng-template #fileIcon>
          <i [class]="fileIconClass"></i>
        </ng-template>
      </div>
      <div class="file-handler__file-info">
        <ng-container *ngIf="!isUploading && downloadUrl; else plainFilename">
          <a
            class="file-handler__file-name"
            [href]="downloadUrl"
            target="_blank"
            rel="noopener"
            [title]="downloadUrl || fileName"
          >
            {{ fileName || fileId }}
          </a>
        </ng-container>
        <ng-template #plainFilename>
          <div class="file-handler__file-name">
            {{ fileName || fileId }}
          </div>
        </ng-template>
        <div class="file-handler__file-meta">
          <ng-container *ngIf="formatSize(fileSize) as sizeText">
            <span>{{ sizeText }}</span>
            <span *ngIf="fileUploadedAtText" class="file-handler__file-meta-separator">•</span>
          </ng-container>
          <span *ngIf="fileUploadedAtText">{{ fileUploadedAtText }}</span>
          <span *ngIf="isUploading" class="file-handler__file-status">
            <i class="fal fa-spinner-third fa-spin"></i>
            Uploading {{ uploadProgress | number:'1.0-0' }}%
          </span>
        </div>
        <div class="file-handler__file-url" *ngIf="downloadDisplayUrl && !isUploading">
          {{ downloadDisplayUrl }}
        </div>
      </div>
      <button *ngIf="!isUploading && showCopyUrl && downloadUrl"
              type="button"
              class="btn-circle-icon btn-circle-medium btn-circle-reversed mr-1"
              (click)="copyDownloadUrl($event)"
              [tooltip]="'Copy URL' | translate"
              placement="top"
              [attr.aria-label]="'Copy URL' | translate">
        <i class="far fa-link"></i>
      </button>
      <confirmation-popover *ngIf="!isUploading"
        className="far fa-trash btn-circle-icon btn-circle-medium btn-circle-reversed btn-danger mr-1"
        (onConfirmed)="deleteFile()"></confirmation-popover>
    </div>
  </ng-template>

  <div class="file-handler__progress" *ngIf="isUploading">
    <div class="file-handler__progress-bar" [style.width.%]="uploadProgress"></div>
  </div>

  <div
    class="file-handler__message"
    *ngIf="statusMessage"
    [class.file-handler__message--error]="statusMessage.variant === 'error'"
    [class.file-handler__message--success]="statusMessage.variant === 'success'"
    [class.file-handler__message--info]="statusMessage.variant === 'info'"
  >
    <div class="file-handler__message-icon">
      <i class="fal" [ngClass]="{
        'fa-exclamation-circle': statusMessage.variant === 'error',
        'fa-check-circle': statusMessage.variant === 'success',
        'fa-info-circle': statusMessage.variant === 'info'
      }"></i>
    </div>
    <div class="file-handler__message-text">
      {{ statusMessage.text }}
    </div>
    <button type="button" class="file-handler__message-close" (click)="onDismissMessage($event)" aria-label="Close message">
      <i class="fal fa-times"></i>
    </button>
  </div>
</div>
